module.exports = __webpack_public_path__ + "img/267.5bdb33de.jpg";